module.exports = __webpack_public_path__ + "lp/img/movie_zoom_dark@2x.b0760fe5.png";